import { MediaWarning } from '../types/media.types.ts';

const mediaWarningMessage = {
  [MediaWarning.SlowConnection]: 'Masz wolne połączenie internetowe.',
};

export default mediaWarningMessage;
